import { render, staticRenderFns } from "./ServicemanTasks.vue?vue&type=template&id=fd63ded6&"
import script from "./ServicemanTasks.vue?vue&type=script&lang=js&"
export * from "./ServicemanTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports